import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=3115420d&scoped=true"
import script from "./BaseSwitch.vue?vue&type=script&lang=js"
export * from "./BaseSwitch.vue?vue&type=script&lang=js"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=3115420d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115420d",
  null
  
)

export default component.exports